
import { EventEmitter } from "events"
import $ from "jquery"
import "bootstrap-transition"
import "bootstrap-modal"
import "bootstrap-modalmanager"
import _template from "lodash/template"

import dismiss_modal from "./dismiss_modal.html._tpl"
import custom_modal from "./custom_modal.html._tpl"
const dismiss_modal_tmpl = _template(dismiss_modal)
const custom_modal_tmpl = _template(custom_modal)

interface ModalOptionsStrict {
  customContent:              boolean
  hideOverflowMobileFixClass: boolean
  class:                      string
  DoOverrideClass:            boolean
  disableBackgroundScrolling: boolean
  keepCurrentScrollTop:       boolean
}
type ModalOptions = Partial<ModalOptionsStrict>

class ModalClass extends EventEmitter {
  /**
   * @param container_or_content The container or content to be displayed
   * @param options Options to use
   * @param options.customContent If true, no wrapper like `.modal-header` and `.modal-body` will be added
   *                              This is set to true when container_or_content has only one top node and
   *                              has `.modal-header` and `.modal-body` already
   */
  public showModalWithContent(container_or_content: string | JQuery, options: ModalOptions = {}): JQuery {
    const opts = Object.assign({
      customContent:              false,
      hideOverflowMobileFixClass: false,
      class:                      "",
      DoOverrideClass:            false,
      disableBackgroundScrolling: false,
      keepCurrentScrollTop:       false,
    }, options)
    // Comments in dev causing issues
    if (typeof container_or_content === "string") {
      container_or_content = container_or_content.replace(/<!--.*?-->/g, "")
    }

    const $container_or_content = $(container_or_content) as unknown as JQuery<Element>
    let $container
    let content
    const currentScrollTop = $(window).scrollTop() || 0

    if ( opts.disableBackgroundScrolling ) {
      $("html").css({"overflow": "hidden", "height": "100vh"})
      // https://stackoverflow.com/a/44853591, fix safari "overflow: hidden" not working issue
      $("body").css({"touch-action": "none", "height": "100vh"})
    }

    if ($container_or_content.length === 1){
      // Is container
      $container = $container_or_content
      content = $container.html()
    }
    else {
      // Is content
      $container = $() // Empty
      content = container_or_content as string
    }

    if ($container.children(".modal-header").length > 0 && $container.children(".modal-body").length > 0){
      opts.customContent = true
    }

    // Always add container classes
    const containerClasses = $container.attr("class")
    if (containerClasses && containerClasses.length > 0){
      opts.class = [opts.class].concat(containerClasses.split(" ")).join(" ")
    }

    return this.createModal($container, content, opts, currentScrollTop)
  }

  public createModal($container: JQuery, content: string, opts: ModalOptionsStrict, currentScrollTop: number): JQuery {
    let modal
    let $modal = $("div")
    const {
      customContent,
      hideOverflowMobileFixClass,
      class: extra_class,
      DoOverrideClass,
    } = opts
    if ( customContent ){
      modal = custom_modal_tmpl({content})
    }
    else{
      modal = dismiss_modal_tmpl({content})
    }

    $modal = $(modal)

    if ( !hideOverflowMobileFixClass ){
      $modal.addClass("modal-overflow-mobile-fix")
    }

    if ( customContent && DoOverrideClass ) {
      $modal.addClass(extra_class)
    }
    else if ( customContent ) {
      // Add default classes
      $modal.addClass("hide fade")
      $modal.addClass(extra_class)
    }
    else {
      $modal.addClass(extra_class)
    }

    // Always add container data
    $modal.data($container.data())

    $modal.modal()

    this.emit("modal_shown")
    $modal.trigger("shown.bs.modal")

    $modal.on("hide", () => {
      $modal.trigger("hidden.bs.modal")

      if ( opts.disableBackgroundScrolling ) {
        $("html").css({"overflow": "", "height": ""})
        $("body").css({"touch-action": "", "height": ""})
      }

      if ( opts.keepCurrentScrollTop ) {
        $(window).scrollTop(currentScrollTop)
      }
    })

    return $modal
  }

  public create(content: string, extra_class = ""){
    const modal = custom_modal_tmpl({content})

    const $modal = $(modal)
    $modal.modal()
    $modal.addClass("modal-overflow-mobile-fix")
    $modal.addClass(extra_class)

    $modal.trigger("shown.bs.modal")
    return $modal
  }

  public showModalWithSelector(selector: string, options = {}){
    const $el = $(selector)
    if ($el.length === 0) { return }
    return this.showModalWithContent(selector, options)
  }

  public hideTopModal(){
    $(".modal:last").modal("hide")
  }

  public hideAllModals(){
    $(".modal").modal("hide")
  }

  public showLoadingIndicator() {
    const $body = $("body")
    $body.addClass("modal-loading")
    $body.modalmanager("loading")
  }
  public hideLoadingIndicator() {
    const $body = $("body")
    $body.modalmanager("removeLoading")
    $body.removeClass("modal-loading")
  }
}

const Modal = new ModalClass()

export default Modal
